// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, object, oneOfType, string } from 'prop-types'
import SelectDynamic from './SelectDynamic'

const SelectFromSet = props => {
  const {
    className = '',
    id,
    selectLabel,
  } = props

  return (
    <div className={`select-from-state ${className}`}>
      { selectLabel && <label id={`${id}-label`}>{selectLabel}</label> }
      <SelectDynamic
        {...props}
        label={selectLabel} />
    </div>
  )
}

SelectFromSet.propTypes = {
  className: string,
  id: string.isRequired,
  options: oneOfType([
    array.isRequired,
    object.isRequired,
  ]),
  selectLabel: string.isRequired,
}

export default SelectFromSet
